<template lang="pug">
v-container(
  fluid
  pa-0
  class="tw-px-0 md:tw-px-4 tw-h-full  md:tw-h-main tw-content-start tw-overflow-hidden"
  style="background: #f5f5fa"
)
  div(class=" tw-flex tw-flex-col tw-h-full tw-overflow-hidden tw-mx-2")
    div(class="tw-flex ")
      v-row(no-gutters)
        v-col
          v-row
            v-col
              kubiqa-dashlet-leads
            v-col
              kubiqa-dashlet-opportunities
            v-col
              kubiqa-dashlet-total-sales

    div(class=" tw-h-full tw-flex tw-flex-grow-default md:tw-max-h-full xs:tw-pt-5 ")
      v-row(
        class=" md:tw-max-h-full md:tw-flex md:tw-flex-row md:tw-flex-grow-default d-flex flex-row flex-grow-1  tw-overflow-y-auto md:tw-overflow-hidden  "
      )
        v-col(cols="12" md="6" class=" tw-h-full  md:tw-flex md:tw-flex-col md:tw-flex-grow-default ")
          kubiqa-activity
        v-col(cols="12" md="6" class="md:tw-flex md:tw-flex-col md:tw-flex-grow-default ")
          v-row(no-gutters class="md:tw-h-full tw-pb-2")
            v-col(class="md:tw-h-full tw-h-64 ")
              kubiqa-leads-list
          v-row(no-gutters align="end" class="md:tw-h-full tw-pt-2 ")
            v-col(class="md:tw-h-full tw-h-64 tw-mb-20")
              kubiqa-opportunities-list
</template>
<script>
import { mapGetters } from 'vuex';
export default {
  computed: {
    //...mapGetters("auth", ["authUser"]),
  },
  created() {
    this.$store.commit('displaySidebar', true);
    this.$store.commit('displayWebsiteToolbar', false);
    this.$store.commit('displayMainToolbar', true);
  },
};
</script>
